/**
 * tourSteps/timeTrackingSteps.js
 * Tour steps for Time Tracking, live timers, effort logging, and workload distribution.
 */

export const timeTrackingSteps = [
    {
        title: 'Team Workload & Capacity Chart',
        description: 'Review real-time task allocations and logged effort across all team members to balance workloads and prevent burnout.',
        selector: '[data-tour="workload-chart"]',
        placement: 'bottom',
    },
    {
        title: 'One-Click Task Timer',
        description: 'Track billable hours effortlessly with the live timer inside any task. Pauses automatically if attendance check-out occurs.',
        selector: '[data-tour="task-timer-widget"]',
        fallbackSelector: '[data-tour="workspace-task-board"]',
        placement: 'bottom',
    },
    {
        title: 'Effort Estimates & Overrun Alerts',
        description: 'Compare logged actual hours against estimated targets. Visual warnings alert you before a task exceeds its budget.',
        selector: '[data-tour="task-metadata-grid"]',
        fallbackSelector: '[data-tour="task-list-table"]',
        placement: 'top',
    },
    {
        title: 'Timesheet & Audit History',
        description: 'Every logged time session is recorded with timestamps, user identities, and duration summaries in the activity log.',
        selector: '[data-tour="task-activity-log"]',
        fallbackSelector: '[data-tour="ai-intelligence-center"]',
        placement: 'top',
    },
];
